export default function Cargando(){

    return(
        <div className="row d-flex justify-content-center mt-5">
            <div className="text-center mt-5">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden"></span>
                </div>
            </div>
        </div>
    )
}